var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPicture)?_c('div',{staticClass:"easyvote-candidate__picture",style:({ backgroundImage: _vm.getUrl})}):_c('div',{staticClass:"easyvote-candidate__picture"})}
var staticRenderFns = []

export { render, staticRenderFns }